import { translate as i18nTranslate } from '@fiverr-private/i18n-react';

export const translate = (key: string): string => i18nTranslate(`brand_pages_perseus.${key}`);
